import { render, staticRenderFns } from "./CombiDealsItem.vue?vue&type=template&id=069e5e46&scoped=true&"
import script from "./CombiDealsItem.vue?vue&type=script&lang=ts&"
export * from "./CombiDealsItem.vue?vue&type=script&lang=ts&"
import style0 from "./CombiDealsItem.vue?vue&type=style&index=0&id=069e5e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e5e46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPlusIcon24px: require('/var/www/packages/theme/components/icons/plus/PlusIcon24px.vue').default,AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,AtomsPrice: require('/var/www/packages/theme/components/atoms/Price.vue').default})
